import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import { BaseUrl, IBaseUrl } from "../..";

const UserCreate = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [photoPreview, setPhotoPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [citydata, setCityData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password_hash: "",
    role: "",
    address: "",
    state: "",
    district: "",
    city: "",
    alternate_contact: "",
    branch_id: "",
    photo: "",
  });

  const [branchData, setBranchData] = useState([]);
  const [permission, setPermission] = useState(null);
  const IsAdmin = localStorage.getItem("IsAdmin");
  const roleId = localStorage.getItem("roleId");
  const Id = localStorage.getItem("id");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    const branchData = await fetchFormData("branch/listdropdown", formData);
    const stateData = await fetchData("active-states");
    const roleData = await fetchFormData("role/listDrop", formData);

    // Handle Branch Data
    if (branchData) {
      const branches = branchData.branches;
      setBranchData(getValueLabel(branches, "branch_name", "id") || []);
    }

    // Handle State Data
    if (stateData) {
      const states = stateData.states;
      setStateData(getValueLabel(states, "state_title", "state_id") || []);
    }

    // Handle Role Data
    if (roleData) {
      const roles = roleData.data;
      const mappedRoles = getValueLabel(roles, "role", "id") || [];
      setRoleData(mappedRoles);
    }
  };

  const fetchDistrictData = async (stateId) => {
    const result = await fetchData(`districts/${stateId}`, {}, "POST");

    if (result) {
      const districts = result.districts;
      setDistrictData(
        getValueLabel(districts, "district_title", "district_id") || []
      );
    }
  };
  const fetchCityData = async (districtId) => {
    const result = await fetchData(`cities/${districtId}`, {}, "POST");

    if (result) {
      const cities = result.cities;
      setCityData(getValueLabel(cities, "city_title", "city_id") || []);
    }
  };

  const handleStateChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      state: value.value,
      district: "",
      city: "",
    }));

    setDistrictData([]);
    setCityData([]);
    fetchDistrictData(value.value);
  };

  const handleDistrictChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      district: value.value,
      city: "",
    }));
    setCityData([]);
    fetchCityData(value.value);
  };

  const handleCityChange = (value) => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        city: value.value,
      }));
    }
  };

  const handleBranchChange = (value) => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        branch_id: value.value,
      }));
    }
  };

  const handleRoleChange = (value) => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        role: value.value,
      }));
    }
  };

  const fetchUserDetails = async (id) => {
    try {
      const result = await fetchData(`user/details/${id}`, {}, "POST");

      if (result && result.user) {
        setFormData(result.user);
        setFormData((prev) => ({
          ...prev,
          password_hash: "",
          alternate_contact: result.user.alternet_contact,
          state: result.user.state_id,
          district: result.user.district_id,
          city: result.user.city,
          photo: "",
        }));
        setPhotoPreview(result.user.employee_image_url);
        fetchDistrictData(result.user.state_id);
        fetchCityData(result.user.district_id);
      } else {
        console.warn("User data not found.");
        setFormData("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setFormData("");
    }
  };

  useEffect(() => {
    fetchAllData();

    if (id) {
      fetchUserDetails(id);
    }
  }, [id]);

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      setFormData((prev) => ({ ...prev, photo: file }));
      reader.onloadend = () => {
        setFormData({
          ...formData,
          image: file,
          imageBase64: reader.result,
        });
      };
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // If file is removed or canceled
      setFormData((prev) => ({ ...prev, photo: null }));
      setPhotoPreview(null);
    }
  };

  // const handlePhoneChange = async (e) => {
  //   const value = e.target.value;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     phone: value,
  //   }));
  //   if (value.length === 10) {
  //     const form = new FormData();
  //     form.append("phone_number", formData.phone);
  //     try {
  //       const response = await fetchFormData(
  //         "check-duplicate-number",
  //         form,
  //         "POST"
  //       );

  //       if (response?.code === 409 || response?.exists) {
  //         topTost({
  //           title: "Phone number already exists!",
  //           icon: "error",
  //         });
  //       } else {
  //         console.log("Phone number is unique");
  //       }
  //     } catch (error) {
  //       console.error("Error checking phone number:", error);
  //       topTost({
  //         title: "Failed to check phone number",
  //         icon: "error",
  //       });
  //     }
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const form = new FormData();

      form.append("name", formData.name || "");
      form.append("email", formData.email || "");
      form.append("phone", formData.phone || "");
      if (!id || formData.password_hash.trim() !== "") {
        form.append("password_hash", formData.password_hash);
      }
      form.append("role", formData.role || "");
      form.append("address", formData.address || "");
      form.append("state_id", formData.state || "");
      form.append("district_id", formData.district || "");
      form.append("city", formData.city || "");
      form.append("alternet_contact", formData.alternate_contact || "");
      form.append("branch_id", formData.branch_id || "");
      form.append("created_by", userId || "");
      form.append("moduleId", M_id);
      if (formData.photo && formData.photo instanceof File) {
        form.append("photo", formData.photo);
      }

      let response;

      if (id) {
        form.append("userId", userId);
        // Edit existing user
        response = await fetchFormData(`user/update/${id}`, form, "POST", true);
      } else {
        // Create new user
        response = await fetchFormData("user/create", form, "POST", true);
      }

      if (
        response.code === 200 &&
        (response.message === "User created successfully" ||
          response.message === "User updated successfully")
      ) {
        topTost({
          // title: id ? "User updated successfully" : "User created successfully",
          title: response.message,
          icon: "success",
        });
        navigate(`/employee/employee-list?id=${M_id}`);
      } else if (response && response.code === 422) {
        topTost({
          title: Array.isArray(response.message)
            ? response.message
            : response.message || "Validation error",
          icon: "error",
        });
      } else {
        topTost({
          title: response.message,
          icon: "success",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit User:" : "Add User:"}
                </span>
              </h5>
            </div>
            <form onSubmit={handleSubmit}>
              {/* Role and Branch */}
              <div className="row mb-4 align-items-center">
                {/* Role */}
                <div className="col-lg-2">
                  <label className="fw-semibold">
                    Role:
                    <span className="text-danger px-2">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={roleData}
                    value={Number(formData.role)}
                    selectedOption={roleData.find(
                      (opt) => opt.value === Number(formData.role)
                    )}
                    defaultSelect="Select Role"
                    onSelectOption={handleRoleChange}
                    icon="feather-user"
                  />
                </div>

                {/* Branch */}
                <div className="col-md-2">
                  <label className="fw-semibold">
                    Branch:
                    <span className="text-danger px-2">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={branchData}
                    icon="feather-home"
                    name="branch_id"
                    value={Number(formData.branch_id)}
                    selectedOption={
                      branchData.find(
                        (opt) => opt.value === formData.branch_id
                      ) || ""
                    }
                    defaultSelect="Select Branch"
                    onSelectOption={handleBranchChange}
                  />
                </div>
              </div>

              {/* Name and Phone */}
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                    icon="feather-user"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone"
                    icon="feather-phone"
                    required
                  />
                </div>
              </div>

              {/* Email and Password */}
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    icon="feather-mail"
                    required
                  />
                </div>
                <div className="col-md-6">
                  {!id && (
                    <Input
                      label="Password"
                      name="password_hash"
                      value={formData.password_hash}
                      onChange={handleChange}
                      placeholder="Password"
                      icon="feather-lock"
                      required
                    />
                  )}

                  {id && (
                    <Input
                      label="New Password"
                      name="password_hash"
                      value={formData.password_hash}
                      onChange={handleChange}
                      placeholder="********"
                      icon="feather-lock"
                    />
                  )}

                  {id && (
                    <small className="ps-text text-center d-block">
                      Forgot your password? Please enter a new password.
                    </small>
                  )}
                </div>
              </div>

              {/* Alternate Contact and Address */}
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Alternate Contact"
                    name="alternate_contact"
                    value={formData.alternate_contact}
                    onChange={handleChange}
                    placeholder="Alternate Contact"
                    icon="feather-phone"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Address"
                    icon="feather-map-pin"
                  />
                </div>
              </div>

              {/* State and District */}
              <div className="row mb-4 align-items-center">
                <div className="col-lg-2">
                  <label className="fw-semibold">State:</label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={stateData}
                    value={Number(formData.state)}
                    selectedOption={
                      stateData.find(
                        (opt) => opt.value === Number(formData.state)
                      ) || ""
                    }
                    defaultSelect="Select State"
                    onSelectOption={handleStateChange}
                    icon="feather-map-pin"
                  />
                </div>

                <div className="col-lg-2">
                  <label className="fw-semibold">District: </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={districtData}
                    value={Number(formData.district)}
                    selectedOption={
                      districtData.find(
                        (opt) => opt.value === Number(formData.district)
                      ) || ""
                    }
                    defaultSelect="Select District"
                    onSelectOption={handleDistrictChange}
                    icon="feather-layers"
                  />
                </div>
              </div>

              {/* City and Photo */}
              <div className="row mb-4 align-items-center">
                <div className="col-lg-2">
                  <label className="fw-semibold">City: </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={citydata}
                    value={Number(formData.city)}
                    selectedOption={
                      citydata.find(
                        (opt) => opt.value === Number(formData.city)
                      ) || ""
                    }
                    defaultSelect="Select City"
                    onSelectOption={handleCityChange}
                    icon="feather-flag"
                  />
                </div>

                <div className="col-md-6 mt-2">
                  <Input
                    label="Photo"
                    name="photo"
                    type="file"
                    onChange={handlePhotoChange}
                    placeholder="Upload Photo"
                  />
                </div>

                {photoPreview && (
                  <img
                    src={photoPreview}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                )}
              </div>

              {/* Submit Button */}
              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserCreate;
